export default import.meta.ROLLDOWN_FILE_URL_Msg57USEadASvSStYSdmzA